import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoGallerySectionComponent } from './photo-gallery-section.component';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';


const routes:Routes=[
  { path: "Gallery", component: PhotoGallerySectionComponent },
]

@NgModule({
  declarations: [PhotoGallerySectionComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forChild(routes),
    NgImageFullscreenViewModule
  ],
 
})
export class GalleryModule { }
